module.exports = __webpack_public_path__ + "img/filter-type-new.5fbeeedf.svg";